// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"252a86d7","453":"ca1227f1","732":"c5a7d678","977":"0a5b7925"}[chunkId] + ".chunk.js";
};